var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.84993H2.5M13.3333 2.5166V5.68327M6.66667 2.5166V5.68327M6.5 18.3499H13.5C14.9001 18.3499 15.6002 18.3499 16.135 18.0911C16.6054 17.8634 16.9878 17.5 17.2275 17.0532C17.5 16.5451 17.5 15.8801 17.5 14.5499V7.89993C17.5 6.56981 17.5 5.90475 17.2275 5.39671C16.9878 4.94982 16.6054 4.58649 16.135 4.35879C15.6002 4.09993 14.9001 4.09993 13.5 4.09993H6.5C5.09987 4.09993 4.3998 4.09993 3.86502 4.35879C3.39462 4.58649 3.01217 4.94982 2.77248 5.39671C2.5 5.90475 2.5 6.56981 2.5 7.89993V14.5499C2.5 15.8801 2.5 16.5451 2.77248 17.0532C3.01217 17.5 3.39462 17.8634 3.86502 18.0911C4.3998 18.3499 5.09987 18.3499 6.5 18.3499Z",
    stroke: "#718096",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.2aa87bd8.svg";
export { ForwardRef as ReactComponent };